import { AuthLayout } from "@/layouts/auth-layout";

interface ErrorPageProps {
  code: string;
  title: string;
  description: string;
  illustration: "server" | "not-found";
}

export function ErrorPage({ code, title, description, illustration }: ErrorPageProps) {
  const illustrationSrc =
    illustration === "server" ? "/images/errors/icon-error.svg" : "/images/errors/error-404.png";

  // Dimensions from Figma: server 537×381, 404 585×413
  // const illustrationSize =
  //   illustration === "server"
  //     ? { width: 537, height: 381 }
  //     : { width: 585, height: 413 };

  return (
    <AuthLayout>
      <div className="flex-1 flex flex-col items-center gap-6 p-12 px-4 lg:p-[100px]">
        {/* Illustration container — 892px wide, centered */}
        <div className="flex flex-col items-center" style={{ width: 892 }}>
          <img
            src={"/images/errors/icon-error.svg"}
            alt={title}
            className="object-contain"
            // style={illustrationSize}
          />
        </div>

        {/* Text block — column, center-aligned */}
        <div className="flex flex-col items-center gap-3 lg:gap-[24px]">
          <div className="flex flex-col items-center gap-[4px]">
            <span className="text-[36px] leading-[44px] lg:text-display font-bold text-black">
              {code}
            </span>
            <p className=" text-[36px] leading-[44px] lg:text-display-giant font-normal text-black  mt-[4px]">
              {title}
            </p>
          </div>
          <p className="text-h2 font-normal text-center text-[#000000] w-full lg:w-[973px]">
            {description}
          </p>
        </div>
      </div>
    </AuthLayout>
  );
}
